/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentGatewayProvider } from './paymentGatewayProvider';


export interface LocationPaymentGatewaySettingResponseDto { 
    id?: number;
    paymentGatewayProvider?: PaymentGatewayProvider;
    gatewayMerchantId?: string | null;
    applePayMerchantId?: string | null;
    googlePayMerchantId?: string | null;
    developerId?: string | null;
    versionNumber?: string | null;
    secretApiKey?: string | null;
    applePayCertificateBase64?: string | null;
    applePayCertificatePassword?: string | null;
}
export namespace LocationPaymentGatewaySettingResponseDto {
}


